import { Provider, inject } from '@angular/core';
import { Ability, AbilityClass, MongoAbility, RawRuleOf, createMongoAbility } from '@casl/ability';
import { AbilityServiceSignal } from '@casl/angular';

export type Action = 'manage' | 'create' | 'read' | 'update' | 'delete' | 'review' | 'escalate' | 'prioritise';

export type Subject =
  | 'all'
  | 'Occurrence'
  | 'IrgReview'
  | 'Activity'
  | 'FavouriteOperator'
  | 'RsoOfficeAssignment'
  | 'PrioritisationConfig'
  | 'OccurrenceHistory'
  | 'AccessControl'
  | 'Session';

export type AppAbility = MongoAbility<[Action, Subject]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;

/** Transport shape of a permission rule as returned by the API (`GET me`). */
export type PermissionRule = RawRuleOf<AppAbility>;

export function provideAppAbility(): Provider {
  return { provide: AppAbility, useValue: createMongoAbility<AppAbility>() };
}

/** Signal-backed ability for templates: `protected readonly can = injectAbility().can;` */
export function injectAbility(): AbilityServiceSignal<AppAbility> {
  return inject<AbilityServiceSignal<AppAbility>>(AbilityServiceSignal);
}
